export default class YouTubeComponent {
    constructor(element) {
        this.element = element;
        this.videoId = this.element.dataset.videoId;
        this.poster = this.element.dataset.poster;

        this.options = {
            autoplay: 1,
            rel: 0,
            modestbranding: 0,
            controls: 1,
            mute: 0,
            start: 0
        };

        this.iframe = null;
        this.init();
    }

    init() {
        if (!this.videoId) {
            console.warn('[YouTubeComponent] Aucun videoId fourni');
            return;
        }

        const wrapper = document.createElement('div');
        wrapper.classList.add('ytb-wrapper');

        const img = document.createElement('img');
        img.classList.add('ytb-poster');
        img.src = this.poster || `https://img.youtube.com/vi/${this.videoId}/hqdefault.jpg`;
        img.alt = 'Video poster';

        const playBtn = this.element.querySelector('.fa-circle-play');
        playBtn.setAttribute('aria-label', 'Lire la vidéo');

        wrapper.appendChild(img);
        wrapper.appendChild(playBtn);
        this.element.appendChild(wrapper);

        wrapper.addEventListener('click', () => this.loadIframe());
    }

    buildSrc() {
        const params = new URLSearchParams({
            autoplay: this.options.autoplay,
            rel: this.options.rel,
            modestbranding: this.options.modestbranding,
            controls: this.options.controls,
            mute: this.options.mute,
            start: this.options.start
        });
        return `https://www.youtube.com/embed/${this.videoId}?${params.toString()}`;
    }

    loadIframe() {
        if (this.iframe) return;

        this.iframe = document.createElement('iframe');
        this.iframe.classList.add('ytb-iframe');
        this.iframe.src = this.buildSrc();
        this.iframe.title = 'YouTube video player';
        this.iframe.frameBorder = '0';
        this.iframe.allow = 'autoplay; encrypted-media;';
        this.iframe.allowFullscreen = true;

        this.element.innerHTML = '';
        this.element.appendChild(this.iframe);
    }
}
